import {Fragment} from 'react';

const Button: (props: any) => JSX.Element = (props: any) => {

    const {type, label, children, className, onClick, attributes} = props;

    const handleClick = () => {
        if(onClick) {
            onClick();
        }
    }

    return (
        <Fragment>
            <button type={type ? type : 'button'} {...attributes} className={`rounded-full border-[1px] border-transparent p-4 ps-10 pe-10 transition-all font-semibold text-[1.4rem] md:text-[1.8rem] button${className ? ` ${className}` : ''}`} onClick={() => handleClick()} >
                {children ?
                    <Fragment>
                        {children}
                    </Fragment>
                    :
                    <Fragment>
                        {label}
                    </Fragment>
                }
            </button>
        </Fragment>
    );
}

export default Button;
